"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plus_sankey_layout = exports.plus_convert_data = void 0;
const SankeyConvert_1 = require("open-sankey/dist/SankeyConvert");
const SankeyPlusViews_1 = require("./SankeyPlusViews");
/* eslint-disable */
// @ts-ignore
const deep_diff = require('deep-diff');
/* eslint-enable */
const plus_convert_data = (data) => {
    if (data.labels) {
        Object.values(data.labels).forEach((l) => {
            if (l.is_edit_raw === undefined) {
                l.is_edit_raw = true;
            }
            if (l.isTextHTML === undefined) {
                l.isTextHTML = false;
                l.is_edit_raw = true;
            }
            if (['haut', 'bas'].includes(l.position_vert)) {
                if (l.position_vert === 'haut') {
                    l.position_vert = 'top';
                }
                else if (l.position_vert === 'bas') {
                    l.position_vert = 'bottom';
                }
            }
            if (['gauche', 'droite'].includes(l.position_horiz)) {
                if (l.position_horiz === 'gauche') {
                    l.position_horiz = 'left';
                }
                else if (l.position_horiz === 'droite') {
                    l.position_horiz = 'right';
                }
            }
            // CONVERT TEXT ZONE TRANSPARENT -> OPACITY (0-100)
            if (l.transparent !== undefined) {
                l.opacity = l.transparent ? 0 : 100;
                delete l.transparent;
            }
        });
    }
    if (!data.view) {
        return;
    }
    // Convert old view (when we copied the entire data)
    data.view.forEach((v) => {
        if (v.view_data.version) {
            SankeyConvert_1.convert_tags(v.view_data);
            SankeyConvert_1.convert_nodes(v.view_data);
            SankeyConvert_1.convert_links(v.view_data);
            let difference = deep_diff.diff(data, v.view_data);
            difference = (difference !== undefined) ? difference : [];
            difference = JSON.parse(JSON.stringify(difference)).map((d) => {
                if (d.kind === 'D') {
                    delete d.lhs;
                }
                if (d.kind === 'A' && d.item.kind === 'D') {
                    delete d.item.lhs;
                }
                if (d.kind === 'E') {
                    delete d.lhs;
                }
                return d;
            });
            difference = difference.filter((d) => !d.path.includes('view'));
            v.view_data.diff = difference;
        }
        if (v.view_data.diff) {
            const d_view = SankeyPlusViews_1.get_data_from_view(data, v.id);
            SankeyConvert_1.convert_data(d_view);
            const converted_master = JSON.parse(JSON.stringify(data));
            SankeyConvert_1.convert_data(converted_master);
            let difference = deep_diff.diff(converted_master, d_view);
            difference = (difference !== undefined) ? difference : [];
            v.view_data.diff = difference;
        }
    });
};
exports.plus_convert_data = plus_convert_data;
const plus_sankey_layout = (data, new_layout) => {
    data.labels = {};
    for (const layout_label in new_layout.labels) {
        data.labels[layout_label] =
            new_layout.labels[layout_label];
    }
};
exports.plus_sankey_layout = plus_sankey_layout;
